// extracted by mini-css-extract-plugin
module.exports = {"box_container":"styles_box_container__B4q8A","hide":"styles_hide__Mgaoi"};